import './index.scss';

import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, Theme, ThemeProvider } from '@mui/material/styles';
import theme from 'app/theme';
import { cache } from 'graphql/apollo-cache';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';
import typeDefs from './graphql/local-schema.graphql';
import store from './redux/store';
// declare module '@mui/styles/defaultTheme' {
//   // eslint-disable-next-line @typescript-eslint/no-empty-interface
//   interface DefaultTheme extends Theme {}
// }

// import reportWebVitals from './reportWebVitals';
const graphQlUrl = process.env.REACT_APP_GRAPHQL_API_URL;

const client = new ApolloClient({
  cache,
  uri: graphQlUrl,
  typeDefs,
  connectToDevTools: true,
});

ReactDOM.render(
  <React.Fragment>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      maxSnack={2}
      autoHideDuration={3500}
    >
      <Provider store={store}>
        <ApolloProvider client={client}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <GoogleReCaptchaProvider reCaptchaKey="6LfjRJAeAAAAAGQQnKZeyUb7pruQCfqdx46OACNF">
                  <App />
                </GoogleReCaptchaProvider>
              </BrowserRouter>
            </ThemeProvider>
          </StyledEngineProvider>
        </ApolloProvider>
      </Provider>
    </SnackbarProvider>
  </React.Fragment>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
